import { render, staticRenderFns } from "./mediaUploader.vue?vue&type=template&id=64e98d30&scoped=true&"
import script from "./mediaUploader.vue?vue&type=script&lang=js&"
export * from "./mediaUploader.vue?vue&type=script&lang=js&"
import style0 from "./mediaUploader.vue?vue&type=style&index=0&id=64e98d30&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e98d30",
  null
  
)

export default component.exports